import {create} from 'zustand';

export interface UiStore {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  showBackButton: boolean;
  setShowBackButton: (showBackButton: boolean) => void;
  onBackButtonClick?: (() => void) | null;
  setOnBackButtonClick: (onClick: any) => void;
  clearOnBackButtonClick: () => void;
  isNavOpen: boolean;
  setIsNavOpen: (isNavOpen: boolean) => void;
}

// The navigation starts open wherever there is room for it next to the page.
const startsWithNavOpen =
  typeof window === 'undefined' || window.innerWidth >= 900;

export const useUiStore = create<UiStore>()(set => ({
  isLoading: false,
  setIsLoading(isLoading) {
    set({isLoading});
  },
  showBackButton: false,
  setShowBackButton(showBackButton) {
    set({showBackButton});
  },
  setOnBackButtonClick(onClick) {
    set({onBackButtonClick: onClick});
  },
  clearOnBackButtonClick() {
    set({onBackButtonClick: null});
  },
  isNavOpen: startsWithNavOpen,
  setIsNavOpen(isNavOpen) {
    set({isNavOpen});
  },
}));
